<template>
	<div>
		<div class="match">
			<div class="wrapper">
				<links v-if="matches" :data="matches"></links>
			</div>
		</div>
		
		<div class="card" v-if="cards">
			<div class="wrapper">
				<div class="card_row">
					<div class="card_col" v-for="card in cards.data" :key="card.id">
						<a href="" class="card_item" :style="'background-image: url(' + card.image_ref + ')'">
							<div class="card_content">
								<div class="card_tag">Статьи</div>
								<div class="card_text">{{card.title}}</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		
		<div class="block __bg __p" v-if="news">
			<div class="wrapper">
				<header class="block_header">
					<div class="block_title">НОВОСТИ</div>
					<router-link :to="{name: 'news'}" class="block_link">Смотреть все</router-link>
				</header>
				
				<base-news :data="news.data" />
			</div>
		</div>
		
		<div class="block __p" v-if="articles">
			<div class="wrapper">
				<header class="block_header">
					<div class="block_title">СТАТЬИ</div>
					<a href="" class="block_link">Смотреть все</a>
				</header>
				
				<base-articles :data="articles.data" />
			</div>
		</div>
		
		<div class="block __p __bg">
			<div class="wrapper">
				<header class="block_header">
					<div class="block_title">СТРИМЫ</div>
					<a href="" class="block_link">Смотреть все</a>
				</header>
				
				<div class="streams">
					<div class="streams_row">
						<div class="streams_col">
							<router-link to="/streams/1" class="streams_item">
								<div class="streams_image">
									<img src="/img/11.jpg" alt="">
									
									<div class="streams_online">В ЭФИРЕ</div>
									<div class="streams_cnt">5 зрителей</div>
								</div>
								<div class="streams_content">
									<div class="streams_ico">
										<img src="https://static-cdn.jtvnw.net/ttv-boxart/Dota%202-85x113.jpg" alt="">
									</div>
									<div class="streams_data">
										<div class="streams_title">УЛУЧШАЮ КОММУНИТИ 2800-3900 по фасту</div>
										<div class="streams_text">JustCooman</div>
									</div>
								</div>
							</router-link>
						</div>
						<div class="streams_col">
							<router-link to="/streams/2" class="streams_item">
								<div class="streams_image">
									<img src="/img/22.jpg" alt="">
									
									<div class="streams_online">В ЭФИРЕ</div>
									<div class="streams_cnt">5 зрителей</div>
								</div>
								<div class="streams_content">
									<div class="streams_ico">
										<img src="https://static-cdn.jtvnw.net/ttv-boxart/Doom%20Eternal-85x113.jpg" alt="">
									</div>
									<div class="streams_data">
										<div class="streams_title">[!title !prime] Doom Eternal - NIGHTMARE DIFFICULTY (Doom all day/night)</div>
										<div class="streams_text">JustCooman</div>
									</div>
								</div>
							</router-link>
						</div>
						<div class="streams_col">
							<router-link to="/streams/3" class="streams_item">
								<div class="streams_image">
									<img src="/img/33.jpg" alt="">
									
									<div class="streams_online">В ЭФИРЕ</div>
									<div class="streams_cnt">5 зрителей</div>
								</div>
								<div class="streams_content">
									<div class="streams_ico">
										<img src="https://static-cdn.jtvnw.net/ttv-boxart/Escape%20From%20Tarkov-85x113.jpg" alt="">
									</div>
									<div class="streams_data">
										<div class="streams_title">Гайд по РАЗВЯЗКЕ !развязка !дикие !звук !гайды !сборки</div>
										<div class="streams_text">JustCooman</div>
									</div>
								</div>
							</router-link>
						</div>
						<div class="streams_col">
							<router-link to="/streams/4" class="streams_item">
								<div class="streams_image">
									<img src="/img/44.jpg" alt="">
									
									<div class="streams_online">В ЭФИРЕ</div>
									<div class="streams_cnt">5 зрителей</div>
								</div>
								<div class="streams_content">
									<div class="streams_ico">
										<img src="https://static-cdn.jtvnw.net/ttv-boxart/Overwatch-85x113.jpg" alt="">
									</div>
									<div class="streams_data">
										<div class="streams_title">Что-то не так со шведами.</div>
										<div class="streams_text">JustCooman</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from "underscore";
	
	import BaseNews from "../components/News/BaseNews";
	import BaseArticles from "../components/Articles/BaseArticles";
	import Links from "../components/Events/Links";
	
	export default {
		components: {
			BaseNews,
			BaseArticles,
			Links
		},
		
		data() {
			return  {
				news: null,
				articles: null,
				matches: null,
				cards: null
			}
		},
		
		computed: {
			
		},
		
		created() {
			this.initNews();
			this.initArticles();
			this.initMatches();
			
			this.axios.get('/api/articles??page=2&sport=overwatch&limit=3')
				.then(({data}) => {
					this.cards = data;
				});
		},
		
		methods: {
			initNews() {
				this.axios.get('/api/news?page=1&sport=overwatch')
					.then(({data}) => {
						this.news = data;
					});
			},
			initArticles() {
				this.axios.get('/api/articles?page=1&sport=overwatch')
					.then(({data}) => {
						this.articles = data;
					});
			},
			initMatches() {
				this.axios.get('/goalserve/esport/events?type=CS GO')
					.then(({data}) => {
						this.matches = _.groupBy(data.res, 'league');
					});
			}
		}
	}
</script>

<style scoped>

</style>